<template>
  <section class="layoutLayout weflix-admin-layoutLayout">
    <TitlePage title="Layout" subtitle="Personalize cores e banners para seu site" :hasMargin="true" />
      <div class="col-form-inner col-6 col-md-6 col-lg-6 layoutLayoutWeflix" v-if="hasReady">
        <!-- Cores -->
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
              <div class="form-input colors">
                <div class="form-label" style="display: block; width: 100%; margin: 0 !important;">
                  <label>Cor do Template<v-tooltip text="Campo obrigatório" location="top">
                    <template v-slot:activator="{ props }">
                      <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                    </template>
                  </v-tooltip></label>
                </div>
                <div class="inputsColors">
                  <input type="color" id="body" name="body"  v-model="color" />
                  <input
                  type="text" 
                  required
                  class="form-control"
                  v-model="color"
                  placeholder="Sua empresa"
                />
                </div>  
                
                <!-- <small class="alertText">Campo obrigatório e deve ser preenchido corretamente.</small> -->
              </div>   
              <div class="form-label">
                <label>Sugestões de Cores<v-tooltip text="Campo obrigatório" location="top">
                  <template v-slot:activator="{ props }">
                    <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                  </template>
                </v-tooltip></label>
              </div>         
              <div class="wrap-suggested-colors" style="display: flex; gap: 10px;">
                <span @click="setColor('#1AB490')" style="background-color:#1AB490;"></span>
                <span @click="setColor('#28C565')" style="background-color:#28C565;"></span>
                <span @click="setColor('#2E8DD6')" style="background-color:#2E8DD6;"></span>
                <span @click="setColor('#904EAC')" style="background-color:#904EAC;"></span>
                <span @click="setColor('#B93126')" style="background-color:#B93126;"></span>
                <span @click="setColor('#E54236')" style="background-color:#E54236;"></span>
                <span @click="setColor('#E47220')" style="background-color:#E47220;"></span>
                <span @click="setColor('#EFBC11')" style="background-color:#EFBC11;"></span>
                <span @click="setColor('#FF69B4')" style="background-color:#FF69B4;"></span>
                <span @click="setColor('#800080')" style="background-color:#800080;"></span>
                <span @click="setColor('#4B0082')" style="background-color:#4B0082;"></span>
                <span @click="setColor('#008080')" style="background-color:#008080;"></span>
                <span @click="setColor('#006400')" style="background-color:#006400;"></span>
                <span @click="setColor('#8B4513')" style="background-color:#8B4513;"></span>
                <span @click="setColor('#4682B4')" style="background-color:#4682B4;"></span>
                <span @click="setColor('#FF4500')" style="background-color:#FF4500;"></span>
                <span @click="setColor('#FFD700')" style="background-color:#FFD700;"></span>
                <span @click="setColor('#00CED1')" style="background-color:#00CED1;"></span>
              </div>
            </div>
        </div>
        <div class="exemplo-cor-section" style="margin-top: 20px;">
          <label style="margin-bottom: 8px; display: block;">Exemplo:</label>
          <button
            :style="{
              backgroundColor: color,
              color: '#fff',
              border: 'none',
              padding: '10px 24px',
              borderRadius: '6px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background 0.2s'
            }"
          >
            Botão de Exemplo
          </button>
        </div>
        <!-- Certificados -->
        <!-- <div class="col-form-inner col-12 col-md-12 col-lg-12">
          <div class="form-group">
            <div class="form-label">
              <label>Certificado</label>
              <small>Envie a assinatura de prenchimento do certificado.
              </small>
            </div>
            <div class="form-file">
              <div class="file-wrapper primary">
                <img
                :src="logoPreview? logoPreview : logo"
                alt="Logo"
                v-show="logoPreview || logo"
              />
                <span class="thumbnail">
                  <span class="icon">
                    <svg
                      width="46"
                      height="39"
                      viewBox="0 0 46 39"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                      ></path>
                      <rect
                        x="1.00049"
                        y="1.40454"
                        width="43.9461"
                        height="36.1909"
                        rx="2.58507"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                      ></rect>
                      <circle
                        cx="14.8948"
                        cy="10.6676"
                        r="3.71629"
                        stroke="#9D9FA3"
                        stroke-width="1.25714"
                      ></circle>
                    </svg>
                  </span>
                  <span class="text">
                    Clique aqui para selecionar a imagem
                  </span>
                  <small>Insira uma imagem maior que 127x127 pixels</small>

                </span>
                <input
                  class="form-control"
                  type="file"
                  @change="updateFilePathLogo"
                  accept=".png, .jpg, .jpeg, .webp"
                />
              </div>
            </div>
          </div>
          <div class="showCertificated">
            <button class="btn">
              <fa icon="fa-file-lines"/> Visualizar Certificado
            </button>
          </div>

      </div> -->
    </div>

    <div class="col-form-inner col-6 col-md-6 col-lg-6 layoutLayoutWeflix" v-if="hasReady">
        <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
              <div class="form-label">
                <label>Banner Principal</label>
                <small>Para uma maior qualidade insira uma imagem maior que 1980x768 pixels</small>
              </div>
              <div class="form-file">
                <img
                  :src="bannerPreview? bannerPreview : banner"
                  alt="Logo"
                  v-show="imagePreviewBanner || banner"
                  class="bannerPreviewPrimaryBannerSite"
                />
                <div :class="bannerWrapperClasses">
                  <span class="thumbnail" v-if="!imagePreviewBanner && !banner">
                    <span class="icon" v-if="loaderImage">
                      <svg
                        width="46"
                        height="39"
                        viewBox="0 0 46 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                          stroke="#9D9FA3"
                          stroke-width="1.25714"
                        ></path>
                        <rect
                          x="1.00049"
                          y="1.40454"
                          width="43.9461"
                          height="36.1909"
                          rx="2.58507"
                          stroke="#9D9FA3"
                          stroke-width="1.25714"
                        ></rect>
                        <circle
                          cx="14.8948"
                          cy="10.6676"
                          r="3.71629"
                          stroke="#9D9FA3"
                          stroke-width="1.25714"
                        ></circle>
                      </svg>
                    </span>
                    <span class="text" v-if="loaderImage">
                      Clique aqui para selecionar a imagem
                    </span>
                    <LoaderImage :hasReady="loaderImage"/>
                  </span>
                  <input
                    class="form-control"
                    type="file"
                    @change="updateFilePathBanner"
                    accept=".png, .jpg, .jpeg, .webp"
                  />
                </div>
              </div>
            </div>
          </div>
         
          <!-- <div class="col-form-inner col-12 col-md-12 col-lg-12">
            <div class="form-group">
              <div class="form-label">
                <label>Banner Sobre</label>
                <small>Banner principal da página sobre, Tamanho mínimo de 1920x480 pixels.</small>

              </div>
              <div class="form-file">
                <div class="file-wrapper primary">
                  <img
                    :src="faviconPreview ? faviconPreview : favicon "
                    alt="Logo"
                    v-show="faviconPreview || favicon"
                    style="width: 50px;"
                  />
                  <span
                    class="thumbnail"
                  >
                    <span class="icon">
                      <svg
                        width="46"
                        height="39"
                        viewBox="0 0 46 39"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                          stroke="#9D9FA3"
                          stroke-width="1.25714"
                        ></path>
                        <rect
                          x="1.00049"
                          y="1.40454"
                          width="43.9461"
                          height="36.1909"
                          rx="2.58507"
                          stroke="#9D9FA3"
                          stroke-width="1.25714"
                        ></rect>
                        <circle
                          cx="14.8948"
                          cy="10.6676"
                          r="3.71629"
                          stroke="#9D9FA3"
                          stroke-width="1.25714"
                        ></circle>
                      </svg>
                    </span>
                    <span class="text">
                      Clique aqui para selecionar a imagem
                    </span>
                  </span>
                 
                  <input
                    class="form-control"
                    type="file"
                    @change="updateFilePathIcon"
                   
                  />
                </div>
              </div>
            </div>
          </div> -->
    </div>
    <div class="layoutLayoutWeflix d-flex ga-4 flex-column align-items-center justify-content-center flex-md-row justify-content-md-end">
      
      <v-btn variant="outlined" border="2" color="primary" size="large" width="140" @click="update" :disabled="!loaderImage" :class="{'disabled': !loaderImage}">Salvar</v-btn>
      <v-btn variant="flat" border="2" color="primary" size="large" @click="clearCache">
        Limpar Cache
      </v-btn>
      
    </div>
  
  </section>
 <Loader :hasReady="hasReady"/>

</template>
<script>
import websiteApi from '@/utils/Weflix/website';
import contentApi from '@/utils/Weflix/content';
import { mapState } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import apiAWS from '@/utils/storage/aws';
import LoaderImage from '@/components/Weflix/LoaderImage';
import { toast } from 'vue3-toastify';
import TitlePage from '@/components/Weflix/titlePage.vue';

export default {
  data(){
      return{
          color:'#ffffff',
          name: '',
          color: '',
          description: '',
          logo: '',
          favicon: '',
          logoPreview: '',
          faviconPreview: '',
          banner: '',
          bannerPreview: '',
          id: '',
          contents: [],
          hasReady: false,
          activeTheme: '',      
          descriptionAbout:'',
          facebook: '',
          gads: '',
          ganalytic: '',
          tagManager: '',
          rdrefreshToken: '',
          rdcode: '',
          rdSecret: '',
          rdClient: '',
          loaderImage: true,
          messageStatusCache: false
      }
  },
  components: {
      Loader,
      LoaderImage,
      TitlePage
  },
  computed: {
    ...mapState(['token', 'layoutWebsite']),
    bannerWrapperClasses() {
      return {
        'file-wrapper': true,
        'primary': true,
        'form-group': window.innerWidth > 600,
        'content-banner': true,
        'banner-image-layout': true
      }
    }
  },
  methods:{
    update(){
      this.hasReady = false;
      this.updateContent();
      this.updateWebsite();
      this.notify('Layout atualizado com sucesso!', 'success');
    },
     setColor(color){
        this.color = color;
     },
     getWebsite() {
      // Agora pega apenas as informações do Vuex (layoutWebsite)
      let layout = this.layoutWebsite || {};

      this.id = layout.id || '';
      this.name = layout.nome || '';
      this.description = layout.description || '';
      this.logo = layout.logo || '';
      this.logoPreview = layout.logoFinal || '';
      this.favicon = layout.favicon || '';
      this.faviconPreview = layout.faviconFinal || '';
      this.url = layout.url || '';
      this.status = layout.status || '';
      this.color = layout.color || '';
      this.activeTheme = layout.typeLayout || '';
      this.descriptionAbout = layout.about || '';

      this.facebook = layout.facebookPixelCode || '';
      this.gads = layout.googleAdsCode || '';
      this.ganalytic = layout.googleAnalyticsCode || '';
      this.tagManager = layout.tagManagerCode || '';
      this.rdrefreshToken = layout.rdrefreshToken || '';
      this.rdcode = layout.rdcode || '';
      this.rdSecret = layout.rdsecretClient || '';
      this.rdClient = layout.rdclienteId || '';
      this.hasReady = true;
    },
    async updateWebsite() {
      // Junta todas as informações locais (possivelmente sobrescritas) com as do layoutWebsite
      const payload = {
        ...(this.layoutWebsite || {}),
        "description": this.description,
        "logo": this.logo,
        "favicon": this.favicon,
        "nome": this.name,
        "status": this.status,
        "url": this.url,
        "color": this.color,
        "logoFinal": this.logoPreview,
        "faviconFinal": this.faviconPreview,
        "typeLayout": this.activeTheme,
        "about": this.descriptionAbout,
        "facebookPixelCode": this.facebook,
        "googleAdsCode": this.gads,
        "googleAnalyticsCode": this.ganalytic,
        "tagManagerCode": this.tagManager,
        "rdrefreshToken": this.rdrefreshToken,
        "rdcode": this.rdcode,
        "rdsecretClient": this.rdSecret,
        "rdclienteId": this.rdClient
      }
      try {
        const response = await websiteApi.editWebsite(this.token, this.id, payload);
        this.getWebsite();
        this.hasReady = true;
      } catch (error) {
        console.error('Erro ao atualizar dados do website:', error);
      }
    },
    async getContents(){
      try {
        const response = await contentApi.getContents(this.token);
        this.contents = response;
        if(this.contents.length > 0){
          this.banner = this.contents[0].pathImage;
          this.bannerPreview = this.contents[0].pathImageFinal;
        }
       
      } catch (error) {
        console.error('Erro ao obter dados do content:', error);
      }
    },
    async updateContent(){
      const payloadPost = [
        {
          "type": 1,
          "pathImage": this.banner,
          "order": 1,
          "status": 1
        }
      ];
      const payloadEdit = [{
        "id": this.contents && this.contents.length > 0 ? this.contents[0].id : null,
        "type": 1,
        "pathImage": this.banner,
        "order": 1,
        "status": 1
      }];

      if(!this.contents || this.contents.length == 0){
        const response = await contentApi.createContent(this.token, payloadPost);
        this.hasReady = true;
      }else{
        const response = await contentApi.editContent(this.token, payloadEdit);
        this.hasReady = true;
      }
    },
    async putFileAws(url, file){
      try {
          const response = await apiAWS.putFileAWS(url, file);
      } catch (error) {
          console.error('Erro ao enviar arquivo para AWS');
      }
    },
    async updateFilePathBanner(event){
      this.loaderImage = false;
        const file = event.target.files[0];
        this.bannerPreview = URL.createObjectURL(file);
        try {
            const response =  await apiAWS.getSignatureImage(this.token, file.name);
            this.putFileAws(response.url, file);
            this.banner = response.token;
            console.debug(response);
            this.loaderImage = true;
        } catch (error) {
            console.error('Erro na geração do TOKEN AWS')
        }
    },
    async clearCache(){
      try {
        const response = await websiteApi.clearCache(this.token);
        this.messageStatusCache = true;
        this.notify('Cache do site limpo!', 'success');
      } catch (error) {
        this.notify('Erro ao limpar cache do site.', 'error');
        console.error('Erro ao limpar cache', error);
      }
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
  },
  created() {
    this.getWebsite();
    this.getContents();
  }
}
</script>
<style>
@import url('./css/layout.css');
</style>
